import { WarningIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { accentTypeConfig } from "./noticeConfig";
import { type AccentNoticeProps } from "./types";

export const NoticeAccent = ({
  type,
  title,
  content,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  actionElement,
  onSecondaryClick,
  className,
  dataTestId,
  layout = "horizontal",
}: AccentNoticeProps) => {
  const { borderColor, iconColor } = accentTypeConfig[type];

  const hasActions = !!(
    primaryButtonText ||
    secondaryButtonText ||
    actionElement
  );

  return (
    <div
      className={cnTwMerge(
        "bg-background/secondary border-l-4 p-4",
        borderColor,
        className,
        {
          "flex flex-col gap-4 max-w-sm": layout === "vertical",
          "flex items-center justify-between": layout === "horizontal",
        },
      )}
      data-testid={dataTestId}
    >
      <div
        className={cnTwMerge("flex gap-2", {
          "items-center": layout === "horizontal",
          "flex-col items-start": layout === "vertical",
        })}
      >
        <WarningIcon className={cnTwMerge("min-w-5 min-h-5", iconColor)} />
        <div>
          <h4 className="body-base-semibold text-text/primary">{title}</h4>
          <p className="body-base-regular text-text/primary">{content}</p>
        </div>
      </div>

      {hasActions ? (
        <div
          className={cnTwMerge("flex", {
            "gap-2": layout === "vertical",
            "gap-4": layout === "horizontal",
          })}
        >
          {secondaryButtonText ? (
            <ThemedButton
              className={cnTwMerge({ "w-1/2": layout === "vertical" })}
              dataTestId={`${secondaryButtonText}-button`}
              onClick={onSecondaryClick}
              variant="secondary"
            >
              {secondaryButtonText}
            </ThemedButton>
          ) : null}
          {primaryButtonText ? (
            <ThemedButton
              className={cnTwMerge({ "w-1/2": layout === "vertical" })}
              dataTestId={`${primaryButtonText}-button`}
              onClick={onPrimaryClick}
              variant="primary"
            >
              {primaryButtonText}
            </ThemedButton>
          ) : null}
          {actionElement}
        </div>
      ) : null}
    </div>
  );
};
